var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5092 59.1051H45.3453V41.7614H51.0176C52.4561 41.7614 53.3061 40.1267 52.4561 38.9498L41.4221 23.6821C40.7192 22.7013 39.2644 22.7013 38.5615 23.6821L27.5276 38.9498C26.6776 40.1267 27.5112 41.7614 28.9661 41.7614H34.6383V59.1051H15.4148C6.83286 58.631 0 50.6049 0 41.9085C0 35.9093 3.25296 30.6784 8.07519 27.8505C7.63384 26.6572 7.40498 25.3821 7.40498 24.0417C7.40498 17.9118 12.358 12.9588 18.4879 12.9588C19.812 12.9588 21.087 13.1876 22.2803 13.629C25.8275 6.10957 33.4777 0.89502 42.3702 0.89502C53.8782 0.911366 63.3592 9.72216 64.4381 20.9522C73.2816 22.4725 80 30.6621 80 39.9306C80 49.8366 72.2844 58.4185 62.5092 59.1051Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.86c53396439788b9ad7fdd58ec744c65.svg";
export { ForwardRef as ReactComponent };